export default "__VITE_ASSET__cf2ef7a2__"